import { render, staticRenderFns } from "./KnowledgeCheckControls.vue?vue&type=template&id=6d2744e8&scoped=true&lang=pug"
import script from "./KnowledgeCheckControls.vue?vue&type=script&lang=ts"
export * from "./KnowledgeCheckControls.vue?vue&type=script&lang=ts"
import style0 from "./KnowledgeCheckControls.vue?vue&type=style&index=0&id=6d2744e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2744e8",
  null
  
)

export default component.exports